import {createSelector} from 'reselect'

import type {State} from '../../../../../reducers/types'
import {getAgentPools, getAgentPoolsOrder, getAgentPoolsReady} from '../../../../../selectors'
import type {AgentPool} from '../../../../../services/rest'
import type {AgentPoolId, AgentPoolsHash} from '../../../../../types'
import {getQueueAllPoolsHref} from '../../../../pages/QueuePage/QueuePage.routes'

import type {
  QueueSidebarItemType,
  QueueSidebarPool,
  QueueSidebarTitle,
  QueueSidebarLink,
  QueueSidebarLoader,
  QueueCountersByPool,
} from './QueueSidebar.types'

const agentPoolsTitle: QueueSidebarTitle = {
  type: 'queue-sidebar-title',
  id: 'agent-pools-title',
  title: 'POOLS',
  level: 0,
}
const allPoolsLink: QueueSidebarLink = {
  type: 'queue-sidebar-link',
  id: 'all-agent-pools-link',
  title: 'All pools',
  level: 0,
  to: getQueueAllPoolsHref(),
  active: false,
}
const activeAllPoolsLink: QueueSidebarLink = {...allPoolsLink, active: true}
const agentPoolsLoader: QueueSidebarLoader = {
  type: 'queue-sidebar-loader',
  id: 'agent-pools-loader',
  title: 'Loading pools...',
  level: 0,
}
export const getPoolCounters: (arg0: State) => QueueCountersByPool = state =>
  state.queueSidebar.counters
export const getQueueSidebarItems: (
  state: State,
  activeAgentPoolId?: AgentPoolId,
) => [ReadonlyArray<QueueSidebarItemType>, number] = createSelector(
  getAgentPools,
  getAgentPoolsOrder,
  getAgentPoolsReady,
  getPoolCounters,
  (state: State, activeAgentPoolId?: AgentPoolId) => activeAgentPoolId,
  (
    agentPoolsHash: AgentPoolsHash,
    agentPoolsOrder: ReadonlyArray<AgentPoolId>,
    ready: boolean,
    counters: QueueCountersByPool,
    activeAgentPoolId?: AgentPoolId,
  ): [ReadonlyArray<QueueSidebarItemType>, number] => {
    let activeItemIndex = -1
    const items: QueueSidebarItemType[] = [agentPoolsTitle]

    if (activeAgentPoolId == null) {
      activeItemIndex = items.push(activeAllPoolsLink) - 1
    } else {
      items.push(allPoolsLink)
    }

    if (ready) {
      let pool: AgentPool | null | undefined
      let agentPoolId: AgentPoolId | null | undefined

      for (let i = 0; i < agentPoolsOrder.length; i++) {
        agentPoolId = agentPoolsOrder[i]
        pool = agentPoolsHash[agentPoolId]

        if (pool != null) {
          const active = activeAgentPoolId === pool.id
          items.push({
            type: 'queue-sidebar-pool',
            id: pool.id,
            title: pool.name,
            level: 0,
            active,
            counters: counters[pool.id!],
          } as QueueSidebarPool)

          if (active) {
            activeItemIndex = i
          }
        }
      }
    } else {
      items.push(agentPoolsLoader)
    }

    return [items, activeItemIndex]
  },
)
